import './FunFactItem.css';
import React, { useEffect, useRef } from 'react';
import { canUseDOM, get, injectImageResolution } from '../../utils';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import { Text, Image } from '@sitecore-jss/sitecore-jss-react';
import LazyPicture from '../atoms/LazyPicture';
import Video from '../atoms/Video';
import { tealiumClickFunc, tealiumMergeClickData } from '../../utils/tealium';
import { convertToAnalyticObject } from '../../utils/analytics';
export const FunFactItem = _ref => {
  let {
    fields,
    inView,
    index = 0,
    titleContainer,
    showNumber,
    params,
    oneItem = true
  } = _ref;
  const sitecoreContext = React.useContext(SitecoreContextReactContext);
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  const pageEditing = Boolean(sitecoreContext && sitecoreContext.pageEditing);
  const itemWrapperRef = useRef(null);
  useEffect(() => {
    if (canUseDOM) {
      if (itemWrapperRef.current) {
        if (itemWrapperRef.current.querySelector('.facts__number') !== null) {
          itemWrapperRef.current.querySelector('.facts__number').style.backgroundImage = `url(${imageSrc})`;
        }
      }
    }
  }, []);
  if (!fields) {
    console.warn('FunFactsItem component render skipped. No fields provided');
    if (pageEditing) {
      return /*#__PURE__*/React.createElement("div", {
        className: "no-data"
      }, " [FunFactsItem component is empty: please provide data source]");
    }
    return null;
  }
  const item = get(fields, 'data.item');
  const hasImageSrc = Boolean(get(item, 'media.jss.value.src'));
  const imageSrc = get(item, 'media.jss.value.src');
  const imageAlt = get(item, 'media.jss.value.alt');
  const videoSrc = get(item, 'video.jss.value.href');
  const videoType = get(item, 'video.jss.value.linktype');
  const videoName = get(item, 'name');
  const description = get(item, 'description.jss');
  const title = get(item, 'title.jss');
  const showNumberCheck = get(showNumber, 'value');
  let eventsAnalytics = get(fields, 'data.eventsAnalytics') || [];
  if (eventsAnalytics.length) {
    eventsAnalytics = convertToAnalyticObject(eventsAnalytics);
  }
  const renderImage = () => {
    return /*#__PURE__*/React.createElement(React.Fragment, null, hasImageSrc && /*#__PURE__*/React.createElement(LazyPicture, {
      className: "facts__image-box"
    }, /*#__PURE__*/React.createElement("source", {
      media: "(min-width:768px)",
      srcSet: `${!oneItem ? injectImageResolution(imageSrc, 340, 255) : injectImageResolution(imageSrc, 460, 340)}`
    }), /*#__PURE__*/React.createElement("img", {
      src: `${injectImageResolution(imageSrc, 325, 245)}`,
      alt: imageAlt,
      className: "facts__image"
    })), videoSrc && videoType && /*#__PURE__*/React.createElement(Video, {
      buttonTopAlignment: true,
      className: "media-wrapper__video ",
      videoSrc: videoSrc,
      videoType: videoType,
      loop: true,
      click: e => {
        tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['videoAnalytics'], params.params), [e, videoName]);
      }
    }));
  };
  const renderVideoImage = isVideoExist => {
    return /*#__PURE__*/React.createElement(React.Fragment, null, hasImageSrc && /*#__PURE__*/React.createElement("div", {
      className: "facts__number",
      onClick: () => {
        isVideoExist && tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['videoAnalytics'], params.params), ['Play', videoName]);
      },
      "data-title": imageAlt
    }, `${(index < 9 ? '0' : '') + (index + 1)}`));
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl,
    anchorUrlParameter: params['Anchor Url Parameter']
  }, /*#__PURE__*/React.createElement("div", {
    ref: itemWrapperRef,
    className: "facts__block m21-fun-fact-item"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-12 d-block d-md-none"
  }, titleContainer && /*#__PURE__*/React.createElement("h4", {
    className: "facts__text-1"
  }, titleContainer)), /*#__PURE__*/React.createElement("div", {
    className: `col-md-4 ${showNumberCheck === true ? 'col-xl-3' : oneItem ? 'col-xl-4' : 'col-xl-3'}`
  }, /*#__PURE__*/React.createElement("div", {
    className: oneItem ? 'facts__image-block-one' : 'facts__image-block'
  }, !pageEditing ? showNumberCheck === true ? /*#__PURE__*/React.createElement("div", {
    className: "facts__number-container"
  }, renderVideoImage(!!videoSrc)) : renderImage() : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("i", null, "Numbers will show in preview mode "), /*#__PURE__*/React.createElement(Image, {
    editable: true,
    field: fields.data.item.media.jss
  })))), /*#__PURE__*/React.createElement("div", {
    className: showNumberCheck === true ? '' : 'col-md-1'
  }), /*#__PURE__*/React.createElement("div", {
    className: `col-md-6 ${showNumberCheck === true ? 'col-xl-7' : 'col-xl-6'}`
  }, /*#__PURE__*/React.createElement("div", {
    className: "facts__info-cnt"
  }, titleContainer && /*#__PURE__*/React.createElement("h3", {
    className: "facts__text-1 d-none d-md-block"
  }, titleContainer), /*#__PURE__*/React.createElement("div", {
    className: "facts__title"
  }, /*#__PURE__*/React.createElement(Text, {
    tag: "",
    field: title
  })), /*#__PURE__*/React.createElement("div", {
    className: "facts__info"
  }, /*#__PURE__*/React.createElement(Text, {
    tag: "",
    field: description
  }))))))));
};
const StyledWrapper = _ref2 => {
  let {
    children,
    rtl,
    anchorUrlParameter
  } = _ref2;
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    anchorUrlParameter: anchorUrlParameter,
    className: `${commonStyles} ${rtl ? rtlStyles : ltrStyles}`
  }, children);
};
export const commonStyles = "cvfmlpn";
export const ltrStyles = "l18smtls";
export const rtlStyles = "rl5nnk2";
export default FunFactItem;